import actionTypes from "../actionTypes";

export const preLoginAction = (data) => ({
  type: actionTypes.loginTypes.PRE_LOGIN,
  payload: data,
});
export const setPreLoginLoaderAction = (data) => ({
  type: actionTypes.loginTypes.SET_PRE_LOGIN_LOADER,
  payload: data,
});
//token not working
export const loginAction = (data) => ({
  type: actionTypes.loginTypes.LOGIN,
  payload: data,
});
//token not working
export const setLoginLoaderAction = (data) => ({
  type: actionTypes.loginTypes.SET_LOGIN_LOADER,
  payload: data,
});
//token working
export const loginAction2 = (data) => ({
  type: actionTypes.loginTypes.LOGIN,
  payload: data,
});
export const logoutAction = () => ({
  type: actionTypes.loginTypes.LOGOUT,
});
export const requestNewPasswordLoaderAction = (data) => ({
  type: actionTypes.loginTypes.SET_REQUEST_NEW_PASSWORD_LOADER,
  payload: data,
});
export const changePasswordLoaderAction = (data) => ({
  type: actionTypes.loginTypes.SET_CHANGE_PASSWORD_LOADER,
  payload: data,
});
export const lastLoginTimeAction = (data) => ({
  type: actionTypes.loginTypes.LAST_LOGIN_TIME,
  payload: data,
});
